export const postMessageChangeStep = (step: number) => {
  window.parent.postMessage(
    {
      type: 'CHANGE_STEP',
      step,
    },
    '*'
  );
};
